"use strict";

const App = {
  ...window.rPlus,
  $loader: $(window.rPlus.loader),
};

export default App;
